import { gql } from '@apollo/client'

export const workPostSheetItemFragment = gql`
  fragment WorkPostSheetItemFragment on WorkPostSheetItem {
    comment
    id
    name
  }
`
